import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';

//import components
import ItemText from './ItemText.js';

const ItemSubSection = ({ clang, list, seeMore }) => {
    return (
        <div>
            {list.map((listItem, index) =>
                listItem.values.map((value, index) =>
                    <div key={index} className="item__subsection">
                        <label className="item__subsection-label">
                            {index === 0 && <span className="item__subsection-label__inner">{lang[clang].item.item_type[listItem.type]}</span>}
                            {index === 0 && <span>:</span>}
                        </label>
                        <div key={index} className="item__subsection-content">
                            <ItemText
                                text={value.label}
                                link={value.link}
                                type={value.entityType}/>
                        </div>
                    </div>)
            )}
        </div>
    );
};

ItemSubSection.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemSubSection);



// WEBPACK FOOTER //
// ./src/components/items/ItemSubSection.js